import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import {
  getFavoriteActivitiesLevelsIds,
  getFavoriteActivitiesLevelsMap,
  getFavoriteActivitiesFilterBy,
} from 'store/entities/favoriteActivities/selectors'
import { setFilter } from 'store/entities/favoriteActivities/actions'
import Select from 'app/components/Select'
import './styles.scss'

const mapStateToProps = state => ({
  levelsIds: getFavoriteActivitiesLevelsIds(state),
  levelsMap: getFavoriteActivitiesLevelsMap(state),
  value: getFavoriteActivitiesFilterBy('byProTrackLevelId')(state),
})

const mapDispatchToProps = dispatch => ({
  onChange(value) {
    dispatch(setFilter('byProTrackLevelId', value))
  },
})

const bc = 'favorite-activities-filter-protracks'

const FavoriteActivitiesFilterProTracks = ({ levelsIds, levelsMap, value, onChange }) => (
  <Fragment>
    <Select
      input={{
        value,
        onChange: e => onChange(e.target.value),
      }}
      className={`${bc}__select-wrapper`}
      classNameSelect={`${bc}__select`}
      getLabel={levelId => levelsMap.get(levelId)}
      options={levelsIds}
      showLabel={false}
      isRowView={false}
    />
  </Fragment>
)

const FavoriteActivitiesFilterProTracksContainer = connect(mapStateToProps, mapDispatchToProps)(
  FavoriteActivitiesFilterProTracks
)

export default FavoriteActivitiesFilterProTracksContainer
